import { BaseWebComponentView } from '../../../framework/BaseWebComponentView';
import { TagDetailsFormWebComponent } from '../../common/tagDetailsForm';
import { GzButtonWebComponent } from '../../../ui/gzButton';
import { WEB_COMPONENT_TAG_DETAILS_FORM } from '../../../webcomponents.constants';
import { TemplateState } from '../../../types/common/types';
import { Subscription } from 'rxjs';
import { TagActionContext } from '../../common/types/TagActionContext';
import { TagData } from '../../types/tag-data';

export class TagPanelView extends BaseWebComponentView {
  public dom: {
    $wrapper: HTMLElement;

    $tagDetailsForm: TagDetailsFormWebComponent;

    $cancelButton: GzButtonWebComponent;
    $saveButton: GzButtonWebComponent;
  };

  private formGroupSubscription: Subscription | null = null;

  private componentStarted = false;

  getDomElements() {
    this.dom = {
      $wrapper: this.shadow.querySelector('.wrapper'),
      $tagDetailsForm: this.shadow.querySelector(WEB_COMPONENT_TAG_DETAILS_FORM),
      $cancelButton: this.shadow.querySelector('#cancel-button'),
      $saveButton: this.shadow.querySelector('#save-button'),
    };

    this.setLoadingState();

    this.getTranslations();
    this.setTranslatedStrings();
  }

  getTranslations() {
    this.commonStrings = this.stringsTranslator.getCommonStrings();
  }

  setTranslatedStrings() {
    this.dom.$cancelButton.innerText = this.dependencies.translateFn('Cancel');
    this.dom.$saveButton.innerText = this.dependencies.translateFn('Save#preserve state');
  }

  public setLoadingState(): void {
    this.resetTemplateState(this.dom.$wrapper);
    this.setTemplateState(this.dom.$wrapper, TemplateState.LOADING);
  }

  public removeLoadingState(): void {
    this.resetTemplateState(this.dom.$wrapper);
  }

  buildSuccessView(viewData: { context: TagActionContext | null; tagData: TagData | null }) {
    this.dom.$tagDetailsForm.injectDependencies(this.dependencies);
    if (viewData.context) {
      this.dom.$tagDetailsForm.formContext = viewData.context;
    }

    if (viewData.tagData?.company) {
      this.dom.$tagDetailsForm.setCompany(viewData.tagData?.company);
    }

    this.dom.$tagDetailsForm
      .start()
      .then(() => {
        if (viewData.tagData) {
          this.dom.$tagDetailsForm.setTagData(viewData.tagData).catch(console.error);
        }

        this.formGroupSubscription = this.dom.$tagDetailsForm.valid$.subscribe({
          next: valid => {
            this.dom.$saveButton.disabled = !valid;
          },
        });

        this.removeLoadingState();
        this.componentStarted = true;
      })
      .catch(console.error);
  }

  buildErrorView(error: Error) {
    this.resetTemplateState(this.dom.$wrapper);
    this.setTemplateState(this.dom.$wrapper, TemplateState.ERROR);
  }

  public get hasUnsavedChanges(): boolean {
    if (!this.componentStarted) {
      // can happen when the error view is shown or if user exits too fast
      return false;
    }

    return this.dom.$tagDetailsForm.controller.view.formGroup.hasUnsavedChanges;
  }

  protected onDisconnect() {
    this.formGroupSubscription?.unsubscribe();
  }
}
